<template>
	<div class="teacher-layout" :style="{ 
		height: isHideRoute() ? '100vh' : '100%',
		width: '100%',
		position: 'relative',
		overflow: 'visible'  /* 改这里！从 hidden → visible */
	}">
		<!-- 手机端菜单按钮 -->
		<div class="menu-btn" v-if="isMobile" @click="openMenu" style="z-index: 2888;">
			<img src="@/ico/stutas/menu.svg" style="width:28px;" alt="">
		</div>

		<!-- 手机端抽屉 -->
		<div class="mobile-menu" style="z-index: 2889;" :class="{ open: menuOpen }" v-if="isMobile && !isHideRoute()">
			<TeacherMenu @click="closeMenu" />
		</div>

		<!-- 桌面端 -->
		<el-container
			:style="{ 
				height: isHideRoute() ? '100vh' : 'calc(100vh - 60px)', 
				width: '100%', 
				
			}"
			v-if="!isMobile">
			
			<el-aside width="220px" style="background:#fff; border-right:1px solid #eee" v-if="!isHideRoute()">
				<TeacherMenu />
			</el-aside>

			<el-container 
				:style="{ 
					padding: isHideRoute() ? '0' : '20px', 
					width:isHideRoute() ?'calc(100vw - 220px)':'calc(100vw - 240px)',
					background: '#f5f7fa', 
					height: '100%',
					boxSizing: 'border-box',
					overflow: visible  /* 改这里！允许子组件正常计算宽度 */
				}">
				<router-view />
			</el-container>
		</el-container>

		<!-- 手机内容 -->
		<div class="mobile-content" v-if="isMobile" :style="{ height: isHideRoute() ? '100vh' : 'auto' }">
			<router-view />
		</div>
	</div>
</template>

<script>
	import TeacherMenu from '@/views/components/TeacherMenu.vue'
	export default {
		components: { TeacherMenu },
		data() {
			return {
				menuOpen: false,
				isMobile: false,
				visible:false,
			};
		},
		mounted() {
			this.checkMobile();
			window.addEventListener("resize", this.checkMobile);
		},
		destroyed() {
			window.removeEventListener("resize", this.checkMobile);
			document.removeEventListener("click", this.handleClickOutside);
		},
		methods: {
			handleClickOutside(e) {
				const menu = document.querySelector('.mobile-menu')
				const btn = document.querySelector('.menu-btn')
				if (menu && !menu.contains(e.target) && !btn.contains(e.target)) {
					this.menuOpen = false
				}
			},
			checkMobile() {
				this.isMobile = window.innerWidth < 992;
			},
			openMenu() {
				this.menuOpen = true;
				document.addEventListener('click', this.handleClickOutside)
			},
			closeMenu() {
				this.menuOpen = false;
				document.removeEventListener('click', this.handleClickOutside)
			},
			isHideRoute() {
				const routePathList = [
					'/teacher/canvasWrap',
					'/teacher/interactiveClassroom',
					'/teacher/WatchTheClass'
				];
				return routePathList.some(path => this.$route.path.startsWith(path));
			}
		}
	};
</script>

<style>
	.teacher-layout {
		box-sizing: border-box;
	}

	.mobile-menu {
		position: fixed;
		top: 0;
		left: 0;
		width: 220px;
		height: 100vh;
		background: #fff;
		z-index: 3000;
		transform: translateX(-100%);
		transition: 0.3s;
	}

	.mobile-menu.open {
		transform: translateX(0);
	}

	.menu-btn {
		position: fixed;
		top: 100px;
		left: 15px;
		z-index: 3001;
		font-size: 20px;
		cursor: pointer;
	}
	el-container{
		div {
			width: 100%;
		}
	}
</style>